import { styled } from '@mui/material/styles'
import { isNil } from 'lodash'
import { ComponentProps, ComponentType, JSXElementConstructor, ReactNode } from 'react'

import TypeAiTimeline from '#/components/FormatCell/Types/AiTimeline'
import TypeAnimalStatus from '#/components/FormatCell/Types/animalStatus'
import TypeAnimalTokenStatus from '#/components/FormatCell/Types/animalTokenStatus'
import { TypeAttachments } from '#/components/FormatCell/Types/attachments'
import TypeAvatarLink from '#/components/FormatCell/Types/AvatarLink'
import TypeBatchesList from '#/components/FormatCell/Types/batchList'
import TypeBoolean from '#/components/FormatCell/Types/boolean'
import TypeBreathingIndicator from '#/components/FormatCell/Types/breathingIndicator'
import TypeButtonLink from '#/components/FormatCell/Types/ButtonLink'
import TypeCalves from '#/components/FormatCell/Types/Calves'
import TypeCcomBadgeLink from '#/components/FormatCell/Types/ccomBadgeLink'
import TypeCComStatus from '#/components/FormatCell/Types/ccomStatus'
import { TypeCCSStatus } from '#/components/FormatCell/Types/ccsStatus'
import TypeCEnv from '#/components/FormatCell/Types/cenv'
import TypeChip from '#/components/FormatCell/Types/chip'
import TypeCollar from '#/components/FormatCell/Types/Collar'
import { TypeCollarIdentification } from '#/components/FormatCell/Types/collarIdentification'
import TypeCollarStatusBadge from '#/components/FormatCell/Types/collarStatusBadge'
import TypeCollarStockBadge from '#/components/FormatCell/Types/collarStockBadge'
import { TypeCollarTag } from '#/components/FormatCell/Types/collarTag'
import { TypeCompanyRelationship } from '#/components/FormatCell/Types/companyRelationship'
import { TypeCompiledDiagnostics } from '#/components/FormatCell/Types/compiledDiagnostics'
import { TypeContractStatus } from '#/components/FormatCell/Types/contractStatus'
import TypeDate from '#/components/FormatCell/Types/date'
import { TypeDiscard } from '#/components/FormatCell/Types/discard'
import TypeDTR from '#/components/FormatCell/Types/dtr'
import TypeEnum from '#/components/FormatCell/Types/enum'
import TypeEventInfos from '#/components/FormatCell/Types/eventInfos'
import { TypeFarmCoverage } from '#/components/FormatCell/Types/farmCoverage'
import { TypeFarmTaskStatus } from '#/components/FormatCell/Types/farmTaskStatus'
import TypeFromNow from '#/components/FormatCell/Types/fromNow'
import TypeHasDataBadge from '#/components/FormatCell/Types/hasDataBadge'
import TypeHealth from '#/components/FormatCell/Types/healthStatus'
import TypeHeatCycles from '#/components/FormatCell/Types/HeatCycles'
import { TypeHeatDetectionMethod } from '#/components/FormatCell/Types/HeatDetectionMethod'
import { TypeHeatIntensity } from '#/components/FormatCell/Types/HeatIntensity'
import TypeHeatStatus from '#/components/FormatCell/Types/heatStatus'
import { TypeHeatStrength } from '#/components/FormatCell/Types/heatStrength'
import { TypeImage } from '#/components/FormatCell/Types/image'
import TypeImportUnrecognizedData from '#/components/FormatCell/Types/importUnrecognizedData'
import TypeInapt from '#/components/FormatCell/Types/inapt'
import TypeInfos from '#/components/FormatCell/Types/Infos'
import TypeInsights from '#/components/FormatCell/Types/insights'
import { TypeIntegrationStatus } from '#/components/FormatCell/Types/integrationStatus'
import TypeItemList from '#/components/FormatCell/Types/itemsList'
import TypeJobStatusBadge from '#/components/FormatCell/Types/jobStatusBadge'
import { TypeLink } from '#/components/FormatCell/Types/link'
import { TypeList } from '#/components/FormatCell/Types/list'
import { TypeMammaryQuarters } from '#/components/FormatCell/Types/MammaryQuarters'
import TypeMinutesToHours from '#/components/FormatCell/Types/minutesToHours'
import TypeMultiData from '#/components/FormatCell/Types/MultiData'
import { TypeNeedPushUp } from '#/components/FormatCell/Types/needPushUp'
import TypeNPSCampaignAnswerGroup from '#/components/FormatCell/Types/npsCampaignAnswerGroup'
import TypeNPSCampaignStatus from '#/components/FormatCell/Types/npsCampaignStatus'
import TypeOutdatedValue from '#/components/FormatCell/Types/OutdatedValue'
import TypeOutdatedVariation from '#/components/FormatCell/Types/OutdatedVariation'
import TypePlansBadge from '#/components/FormatCell/Types/plansBadge'
import TypePortfolio from '#/components/FormatCell/Types/portfolio'
import { TypePPI } from '#/components/FormatCell/Types/ppi'
import TypePregnancyDiagnostics from '#/components/FormatCell/Types/pregnancyDiagnostics'
import TypeProduction from '#/components/FormatCell/Types/production'
import TypeProductionBadge from '#/components/FormatCell/Types/productionBadge'
import TypeProtocolStatus from '#/components/FormatCell/Types/protocolStatus'
import TypeQuickInfo from '#/components/FormatCell/Types/quickInfo'
import TypeReproduction from '#/components/FormatCell/Types/reproduction'
import { TypeRoute } from '#/components/FormatCell/Types/route'
import { TypeRoutePermissions } from '#/components/FormatCell/Types/routePermissions'
import { TypeSanitaryProtocolStatus } from '#/components/FormatCell/Types/sanitaryProtocolStatus'
import { TypeSemenIdentification } from '#/components/FormatCell/Types/semenIdentification'
import TypeSequencer from '#/components/FormatCell/Types/sequencer'
import { TypeStatusChip } from '#/components/FormatCell/Types/statusChip'
import TypeString from '#/components/FormatCell/Types/string'
import TypeStringArray from '#/components/FormatCell/Types/stringArray'
import TypeThi from '#/components/FormatCell/Types/thi'
import TypeTimestamp from '#/components/FormatCell/Types/timestamp'
import { TypeTreatment } from '#/components/FormatCell/Types/treatment'
import { TypeTroughLevel } from '#/components/FormatCell/Types/troughLevel'
import TypeUnitStatus from '#/components/FormatCell/Types/unitStatus'
import TypeVariation from '#/components/FormatCell/Types/Variation'
import TypeWarningBadge from '#/components/FormatCell/Types/warningBadge'
import { TypeWithdrawalPeriodIndicador } from '#/components/FormatCell/Types/withdrawalPeriodIndicador'

/* prettier-ignore */
export const FormatCellTypes = {
  'ai-timeline':                  TypeAiTimeline,
  'animal_token_status':          TypeAnimalTokenStatus,
  'animal-status':                TypeAnimalStatus,
  'attachments':                  TypeAttachments,
  'avatar-link':                  TypeAvatarLink,
  'batches_list':                 TypeBatchesList,
  'boolean':                      TypeBoolean,
  'breathing_indicator':          TypeBreathingIndicator,
  'button-link':                  TypeButtonLink,
  'c-env':                        TypeCEnv,
  'calves':                       TypeCalves,
  'campaign_answer_group':        TypeNPSCampaignAnswerGroup,
  'campaign_status':              TypeNPSCampaignStatus,
  'ccom_status':                  TypeCComStatus,
  'ccom-badge-link':              TypeCcomBadgeLink,
  'chip':                         TypeChip,
  "collar_tag":                   TypeCollarTag,
  'collar-badge':                 TypeCollar,
  'collar-identification':        TypeCollarIdentification,
  'collar-status-badge':          TypeCollarStatusBadge,
  'collar-stock-badge':           TypeCollarStockBadge,
  'company_relationship':         TypeCompanyRelationship,
  'compiled_diagnostics':         TypeCompiledDiagnostics,
  'contract_status':              TypeContractStatus,
  'date':                         TypeDate,
  'discard_field':                TypeDiscard,
  'dtr':                          TypeDTR,
  'enum':                         TypeEnum,
  'event-infos':                  TypeEventInfos,
  'farm_coverage':                TypeFarmCoverage,
  "farm_task_status":             TypeFarmTaskStatus,
  'from-now':                     TypeFromNow,
  'has-data-badge':               TypeHasDataBadge,
  'health_status':                TypeHealth,
  'health-group-treatments':      TypeTreatment,
  'heat_cycles':                  TypeHeatCycles,
  'heat-detection-method':        TypeHeatDetectionMethod,
  'heat-intensity':               TypeHeatIntensity,
  'heat-status':                  TypeHeatStatus,
  'heat-strength':                TypeHeatStrength,
  'image':                        TypeImage,
  'import-unrecognized-data':     TypeImportUnrecognizedData,
  'inapt':                        TypeInapt,
  'infos':                        TypeInfos,
  'insights':                     TypeInsights,
  'integration_status':           TypeIntegrationStatus,
  'items-list':                   TypeItemList,
  'job-status-badge':             TypeJobStatusBadge,
  'link':                         TypeLink,
  'list':                         TypeList,
  'mammary_quarters':             TypeMammaryQuarters,
  'mastitis_status':              TypeCCSStatus,
  'minutes-to-hours':             TypeMinutesToHours,
  'multi-data':                   TypeMultiData,
  "need_push_up":                 TypeNeedPushUp,
  'outdated-value':               TypeOutdatedValue,
  'outdated-variation':           TypeOutdatedVariation,
  'plan':                         TypePlansBadge,
  'portfolio':                    TypePortfolio,
  'ppi_status':                   TypePPI,
  'pregnancy_diagnostics':        TypePregnancyDiagnostics,
  'production_status':            TypeProduction,
  'production-badge':             TypeProductionBadge,
  'protocol_status':              TypeProtocolStatus,
  'quick-info':                   TypeQuickInfo,
  'reproduction_status':          TypeReproduction,
  'role-route-permission':        TypeRoutePermissions,
  'route':                        TypeRoute,
  "sanitary_protocol_status":     TypeSanitaryProtocolStatus,
  'semen-identification':         TypeSemenIdentification,
  'sequencer':                    TypeSequencer,
  'status_chip':                  TypeStatusChip,
  'string':                       TypeString,
  'string-array':                 TypeStringArray,
  'thi':                          TypeThi,
  'timestamp':                    TypeTimestamp,
  'trough_level':                 TypeTroughLevel,
  'unit-status':                  TypeUnitStatus,
  'variation':                    TypeVariation,
  'warning-badge':                TypeWarningBadge,
  "withdrawal-period-indicator":  TypeWithdrawalPeriodIndicador
} as const

export type FormatCellType = keyof typeof FormatCellTypes

type IsAny<TValue> = 0 extends 1 & TValue ? true : false

/**
 * `true` quando ao menos uma propriedade de `TProps` é `any` — marca de um
 * renderer `.jsx` sem tipos (um parâmetro desestruturado sem default vira `any`,
 * ex.: `({ value, level }) => ...`). Um renderer `.tsx` real tem todas as props
 * com tipos concretos, então nunca dispara.
 */
type HasAnyProp<TProps> = true extends {
  [Key in keyof TProps]: IsAny<TProps[Key]>
}[keyof TProps]
  ? true
  : false

/**
 * Resolve as props de um renderer registrado em `FormatCellTypes`.
 * Renderers `.tsx` (props totalmente tipadas, com chaves literais) têm suas props
 * inferidas e validadas. Renderers `.jsx` (sem tipos — cuja inferência resulta em
 * `any`, index signature ou ao menos uma prop `any`) caem em `Record<string, any>`,
 * ou seja, qualquer prop é aceita.
 */
type PropsOf<TComponent extends JSXElementConstructor<any>> =
  ComponentProps<TComponent> extends infer Props
    ? Props extends object
      ? string extends keyof Props
        ? Record<string, any>
        : HasAnyProp<Props> extends true
          ? Record<string, any>
          : Props
      : Record<string, any>
    : never

/**
 * Conteúdo exibido ao lado da célula; quando função, recebe as props do renderer
 * (`value`, `bold`, `level` etc.).
 */
export type FormatCellSlot<TProps> = ReactNode | ((typeProps: TProps) => ReactNode)

/**
 * União discriminada por `type`: ao informar `type="collar-badge"`, as props do
 * renderer correspondente (`TypeCollar`) passam a ser inferidas e checadas.
 */
export type FormatCellProps = {
  [Type in FormatCellType]: {
    /** Conteúdo exibido antes da célula, mesmo quando ela não tem valor. */
    prefix?: FormatCellSlot<PropsOf<(typeof FormatCellTypes)[Type]>>
    /** Conteúdo exibido depois da célula, mesmo quando ela não tem valor. */
    suffix?: FormatCellSlot<PropsOf<(typeof FormatCellTypes)[Type]>>
    type: Type
  } & PropsOf<(typeof FormatCellTypes)[Type]>
}[FormatCellType]

const Wrapper = styled('div')({
  '& > span:empty': { display: 'none' },
  'alignItems': 'center',
  'display': 'flex',
  'gap': 5,
})

const resolveSlot = (slot: FormatCellSlot<any>, typeProps: Record<string, any>): ReactNode =>
  typeof slot === 'function' ? slot(typeProps) : slot

const hasContent = (content: ReactNode) =>
  !isNil(content) && typeof content !== 'boolean' && content !== ''

function FormatCell({ prefix, suffix, type, ...rest }: FormatCellProps) {
  const Component = (FormatCellTypes[type] ?? TypeString) as ComponentType<any>
  const resolvedPrefix = resolveSlot(prefix as FormatCellSlot<any>, rest)
  const resolvedSuffix = resolveSlot(suffix as FormatCellSlot<any>, rest)

  if (!hasContent(resolvedPrefix) && !hasContent(resolvedSuffix)) {
    return <Component {...rest} />
  }

  return (
    <Wrapper>
      {hasContent(resolvedPrefix) && <span>{resolvedPrefix}</span>}
      <Component {...rest} />
      {hasContent(resolvedSuffix) && <span>{resolvedSuffix}</span>}
    </Wrapper>
  )
}

export default FormatCell
